import * as React from 'react'
import {
  Box,
  Button,
  Heading,
  Stack,
  Text,
  List,
  ListItem,
  ListIcon,
  useColorModeValue as mode,
  Img,
} from '@chakra-ui/react'
import { Chapter } from './Chapter'
import { MdDone } from 'react-icons/md'

export const CourseSyllabus = (data) => {
  return (
    <Box as="section" bg="white">
      <a id="syllabus" />
      <Box maxW={{ base: 'xl', md: '7xl' }} mx="auto">
        <Stack
          direction={{ base: 'column', lg: 'row' }}
          spacing={{ base: '20', lg: '8', md: '8', xs: '8' }}
          justify="space-between"
          pb="2em"
          alignItems="center"
        >
          <Box pt="4em" px="8">
            <Heading
              display="block"
              size="2xl"
              textAlign="left"
              fontFamily="Tomato Grotesk"
              color={mode('gray.900', 'gray.900')}
            >
              {data.overview.title}
            </Heading>
            <Text
              my="10"
              as="div"
              maxWidth="600px"
              textAlign="left"
              color={mode('gray.800', 'gray.400')}
              fontSize="lg"
            >
              <p>
                {data.overview.subtitle}
              </p>
              <List spacing={3} mt="6">
                {data.overview.features.map((feature, index) => (
                  <ListItem key={index} ml="24px">
                    <ListIcon as={MdDone} color="blue.600" ml="-25px" mt="4px" position="absolute" />
                    <span dangerouslySetInnerHTML={{ __html: feature }} />
                  </ListItem>
                ))}
              </List>
            </Text>
          </Box>
          <Box marginTop={{ base: '6', md: '0' }} padding="30px" alignSelf="center" alignContent="center">
            <Img
              pos="relative"
              width={{ base: '75%', lg: '450px' }}
              htmlWidth="863"
              htmlHeight="982"
              objectFit="cover"
              src="./img/syllabus-3d-calendar.png"
              alt="Data Science Course Syllabus"
              pr="3"
              bottom={{ base: '', md: '-40px' }}
            />
          </Box>
        </Stack>

        <Box pt="4" pb="8">
          <Box px={{ base: '6', md: '8' }}>
            {data.chapters.map((chapter, index) => (
              <Chapter key={index} data={chapter} />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}